import { useState } from "react";
import { useTranslation } from "react-i18next";
import { bookingsApi } from "@/lib/bookings-api";

export function CheckoutRecoveryActions({ token, publicId, onAnotherCard }: {
  token: string; publicId: string; onAnotherCard: () => void;
}) {
  const { t } = useTranslation();
  const [sending, setSending] = useState(false);
  const [notice, setNotice] = useState("");
  const [failed, setFailed] = useState(false);
  async function email() {
    if (sending) return;
    setSending(true); setNotice(""); setFailed(false);
    try {
      const result = await bookingsApi.emailCheckoutRecovery(token, publicId);
      if (!result.delivered) throw new Error("not_delivered");
      setNotice(t("checkout.recovery.email_sent", {
        defaultValue: "We've emailed your secure checkout link. Your booking is not yet confirmed. Current hold deadline: {{deadline}}.",
        deadline: new Date(result.holdUntil).toLocaleString(),
      }));
    } catch {
      setFailed(true);
      setNotice(t("checkout.recovery.email_failed", "We couldn't send the email. You can retry payment here, or request another email in two minutes."));
    } finally { setSending(false); }
  }
  return <section className="mb-4 rounded-xl border border-border p-4" aria-label={t("checkout.recovery.actions", "Payment recovery options")}>
    <div className="flex flex-wrap gap-3">
      <button type="button" className="rounded-lg border px-4 py-2 text-sm font-semibold" onClick={onAnotherCard}>
        {t("checkout.recovery.another_card", "Try another card")}
      </button>
      <button type="button" disabled={sending} className="rounded-lg border px-4 py-2 text-sm font-semibold disabled:opacity-50" onClick={() => void email()}>
        {sending ? t("checkout.recovery.sending", "Sending…") : t("checkout.recovery.email_action", "Pay by link later")}
      </button>
    </div>
    <p className="mt-3 text-sm">{t("checkout.recovery.wallet_hint", "You can also use a wallet if a supported option is shown in the payment section below.")}</p>
    {notice && <p className="mt-3 text-sm" role={failed ? "alert" : "status"}>{notice}</p>}
  </section>;
}
